package com.anjuros.website.templates.template5.modules

import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template5.util.ResKey
import com.varabyte.kobweb.compose.ui.Modifier

enum class Template5HeroFeature(
    val icon: String,
    val title: ResKey,
    val text: ResKey
) {
    Template5HeroFeatureCard1(
        icon = "template5_hero1.svg",
        title = ResKey.TEMPLATE5_HERO_FEATURE1_TITLE,
        text = ResKey.TEMPLATE5_HERO_FEATURE1_TEXT
    ),

    //------------------------------------------------
    // FLOATING FEATURE 2
    //------------------------------------------------

    Template5HeroFeatureCard2(
    icon = "template5_hero2.svg",
    title = ResKey.TEMPLATE5_HERO_FEATURE2_TITLE,
    text = ResKey.TEMPLATE5_HERO_FEATURE2_TEXT
    ),

    //------------------------------------------------
    // FLOATING FEATURE 3
    //------------------------------------------------

    Template5HeroFeatureCard3(
    icon = "template5_hero3.svg",
    title = ResKey.TEMPLATE5_HERO_FEATURE3_TITLE,
    text = ResKey.TEMPLATE5_HERO_FEATURE3_TEXT
    )
}